import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';

const UIPage = MojitoCore.Presentation.UIPage;
import HomePageImpl from './home-page.js';

/**
 * @namespace HomePage
 * @memberof Mojito.Applications.Sports.Pages
 */

/**
 * The home page.
 *
 * @class HomePage
 * @extends Mojito.Core.Presentation.UIPage
 * @memberof Mojito.Applications.Sports.Pages.HomePage
 */

/**
 * HomePage prop types.
 *
 * @property {boolean} [showQuickStartGuide = false] - Flag to render the Quick Start Guide component on the home page.
 *
 * @memberof Mojito.Applications.Sports.Pages.HomePage
 */
const propTypes = {
    showQuickStartGuide: PropTypes.bool,
};

const defaultProps = {
    showQuickStartGuide: false,
};

export default UIPage('HomePage', HomePageImpl, propTypes, defaultProps);
